__turbopack_context__.v({
  "action": "PinnedMessageBanner-module-scss-module__e-Eszq__action",
  "clip": "PinnedMessageBanner-module-scss-module__e-Eszq__clip",
  "content": "PinnedMessageBanner-module-scss-module__e-Eszq__content",
  "count": "PinnedMessageBanner-module-scss-module__e-Eszq__count",
  "heading": "PinnedMessageBanner-module-scss-module__e-Eszq__heading",
  "reveal": "PinnedMessageBanner-module-scss-module__e-Eszq__reveal",
  "row": "PinnedMessageBanner-module-scss-module__e-Eszq__row",
});
